'use client';

import { useEffect, useState } from 'react';

import { useReducedMotion } from './use-reduced-motion';

export function ConversationViz({ active }: { active: boolean }) {
  const reducedMotion = useReducedMotion();
  const [tick, setTick] = useState(0);

  // Sequential animation: increment tick every 600ms (calm, natural pace)
  // Each message animates over 400ms (defined in CSS transition)
  useEffect(() => {
    if (!active || reducedMotion) return;

    // Start immediately when active, then stagger each message
    const id = setInterval(() => {
      setTick((t) => {
        const next = t + 1;
        if (next >= 4) {
          clearInterval(id); // Stop after all 4 messages shown
        }
        return next;
      });
    }, 600);

    return () => clearInterval(id);
  }, [active, reducedMotion]);

  // Determine what to show based on tick
  // 0: Q1 appears
  // 1: A1 appears
  // 2: Q2 appears
  // 3: A2 appears
  const revealed = !active ? 0 : reducedMotion ? 4 : Math.min(tick, 4);

  return (
    <div className="conversation-viz">
      {/* Q1 */}
      <div className={`conv-bubble-wrapper ${revealed >= 1 ? 'on' : ''}`}>
        <div className="conv-number">L</div>
        <div className="conv-bubble conv-q">
          When you think of your mom, what&rsquo;s the first thing that comes to mind?
        </div>
      </div>

      {/* A1 */}
      <div className={`conv-bubble-wrapper ${revealed >= 2 ? 'on' : ''}`}>
        <div className="conv-bubble conv-a">
          Her laugh. When I was a kid, I&rsquo;d wake up just about every Saturday morning to her
          laughing on the phone downstairs.
        </div>
      </div>

      {/* Q2 */}
      <div className={`conv-bubble-wrapper ${revealed >= 3 ? 'on' : ''}`}>
        <div className="conv-number">L</div>
        <div className="conv-bubble conv-q">Who was she talking to?</div>
      </div>

      {/* A2 */}
      <div className={`conv-bubble-wrapper ${revealed >= 4 ? 'on' : ''}`}>
        <div className="conv-bubble conv-a">
          Usually her sister Peggy. They&rsquo;d talk for hours. I couldn&rsquo;t tell you what they
          talked about, I just remember hearing them laugh.
        </div>
      </div>
    </div>
  );
}
